import React, { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import {
  fetchData,
  getEncryptedRoute,
  getTranslatedValue,
  hasSpecialCharacters,
  isSpecificSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
  buildDropdownAudit,
} from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { AddHotelHeader } from './AddHotelHeader'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const AddHotelBasicInfo: FC = () => {
  let t = Tr()

  const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''
  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''
  const vendorId2 = (location.state as any)?.vendorId || ''
  const [hotelDetails, setHotelDetails] = useState([])
  const { menuId } = useMenuIdPermissions()
  const specialCharacterRegex = /^[a-zA-Z\u0400-\u04FF<>,-."'*()`’ ]*$/;
;
  const lang = useLang()

  if (vendorId2 != '' && vendorId2 != null) {
    sessionStorage.setItem('vendor', vendorId2)
    sessionStorage.setItem('selectedVendor', vendorId2)
  }

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [hotelNameEN, setHotelNameEN] = useState('')
  const [hotelNameRU, setHotelNameRU] = useState('')
  const [hotelNameUZ, setHotelNameUZ] = useState('')
  const [contactPersonName, setContactPersonName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [vendorList, setVendorList] = useState([])
  const [selectedVendor, setSelectedVendor] = useState(null)

  // category list state start
  const [subCategoryList, setSubCategoryList] = useState([])
  const [subCategorySelectedOptions, setSubCategorySelectedOptions] = useState<any>([])
  var subCategoryId = subCategorySelectedOptions
  // category list state end

  // hotel class list state start

  const [hotelClassList] = useState([
    { value: 'No Star', label: `${t("No Star")}` },
    { value: '1', label: `1 ${t("Star")}` },
    { value: '2', label: `2 ${t("Star")}` },
    { value: '3', label: `3 ${t("Star")}` },
    { value: '4', label: `4 ${t("Star")}` },
    { value: '5', label: `5 ${t("Star")}` },
  ])
  const [serviceList] = useState([
    { value: '1', label: 'Hotel & Resort' },
    { value: '2', label: 'Pension & Stays' },
  ])
  const [hotelClassSelectedOptions, setHotelClassSelectedOptions] = useState<any>()
  // hotel class list state start
  const [propertyTypeList, setPropertyList] = useState([])
  const [propertyTypeSelectedOptions, setPropertyTypeSelectedOptions] = useState<any>()
  const [selectedService, setSelectedService] = useState<any>()
  // service language list state start
  const [primaryLanguageList] = useState([
    { value: 'English', label: 'English' },
    { value: 'Russian', label: 'Русский' },
    { value: 'Uzbek', label: 'O’zbekcha' },
  ])
  const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({
    value: 'English',
    label: 'English',
  })

  // old dropdown states for audit labels
  const [oldPrimaryLanguage, setOldPrimaryLanguage] = useState<any>(null)
  const [oldHotelClass, setOldHotelClass] = useState<any>(null)
  const [oldPropertyType, setOldPropertyType] = useState<any>(null)
  const [oldSubCategory, setOldSubCategory] = useState<any>(null)
  sessionStorage.setItem('primaryLanguage', primaryLanguageSelectedOptions.value)

  // service language list state end
  const changePrimaryLanguage = (val: any) => {
    setPrimaryLanguageSelectedOptions(val)
    removeError('primaryLanguage')
    sessionStorage.setItem('primaryLanguage', val.value)
  }

  // set error state
  const [error, setError] = useState([
    {
      subCategoryId: '',
      hotelClass: '',
      hotelNameEN: '',
      hotelNameRU: '',
      hotelNameUZ: '',
      propertyType: '',
      contactPersonName: '',
      email: '',
      phoneNumber: '',
      primaryLanguage: '',
      vendorId: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const propertyTypeListAPIcall = async () => {
    var param = {
      // categoryId: selectedService != '' && selectedService != undefined ? selectedService : '',
      categoryId: '1,2',
    }
    var res = await fetchData('vendor/public/propertytypeList', param)

    if (res.status == '200') {
      const groupedOptions: any = []

      // Define category labels
      const categoryLabels: { [key: string]: string } = {
        '1': 'Hotel & Resort',
        '2': 'Pension & Stays',
      }

      const categoryMap: { [key: string]: any } = {}

      res.data.forEach((val: any) => {
        const categoryId = val.categoryId.toString()
        if (!categoryMap[categoryId]) {
          categoryMap[categoryId] = {
            label: categoryLabels[categoryId] || 'Unknown Category',
            options: [],
          }
        }
        categoryMap[categoryId].options.push({
          value: val.propertytypeId,
          label: getTranslatedValue(lang, val, '_name'),
          categoryId: val.categoryId,
        })
      })

      // Convert grouped data into array format
      Object.values(categoryMap).forEach((group) => {
        groupedOptions.push(group)
      })

      setPropertyList(groupedOptions)
    } else {
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    propertyTypeListAPIcall()
  }, [])

  const hotelSubcategoryAPIcall = async (categoryId: any) => {
    // const param = {
    //   categoryId: selectedService != '' && selectedService != undefined ? selectedService : '',
    // }
    const param = {
      categoryId: categoryId,
    }

    var res = await fetchData('vendor/public/hotelSubcategory', param)

    if (res.status == '200') {
      var opt: any = []
      
      res.data.map((val: any) => {
        opt.push({
          value: val.subcategoryId, label: getTranslatedValue(lang, val, '_name'),
        })
      })

      setSubCategoryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (subCategorySelectedOptions.length == 0) {
      errorTmp[0].subCategoryId = t('Property Category Is Required')
      isValid = false
    }
    if (
      (editHotelId === '' || editHotelId === null || editHotelId === undefined) &&
      (selectedVendor === null ||
        selectedVendor['value'] === '' ||
        selectedVendor['value'] === null ||
        selectedVendor['value'] === undefined)
    ) {
      errorTmp[0].vendorId = t('Vendor Is required')
      isValid = false
    } else {
      errorTmp[0].vendorId = ''
    }
    if (
      hotelClassSelectedOptions == undefined ||
      hotelClassSelectedOptions == null ||
      hotelClassSelectedOptions == ''
    ) {
      errorTmp[0].hotelClass = t('Property Class Is Required')
      isValid = false
    }
    if (
      propertyTypeSelectedOptions == undefined ||
      propertyTypeSelectedOptions == null ||
      propertyTypeSelectedOptions == ''
    ) {
      errorTmp[0].propertyType = t('Property Type Is Required')
      isValid = false
    }
    if (primaryLanguageSelectedOptions.value == 'English') {
      if (
        hotelNameEN.trim() == '' ||
        hotelNameEN.trim() == null ||
        hotelNameEN.trim() == undefined
      ) {
        errorTmp[0].hotelNameEN = t('Property Name Is Required')
        isValid = false
      }
      else if (!isSpecificSpecialCharacters(hotelNameEN.trim(), specialCharacterRegex)) {
        errorTmp[0].hotelNameEN = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
        isValid = false
      }
    } else if (primaryLanguageSelectedOptions.value == 'Russian') {
      if (
        hotelNameRU.trim() == '' ||
        hotelNameRU.trim() == null ||
        hotelNameRU.trim() == undefined
      ) {
        errorTmp[0].hotelNameRU = t('Property Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(hotelNameRU.trim(), specialCharacterRegex)) {
        errorTmp[0].hotelNameRU = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
        isValid = false
      }
    } else if (primaryLanguageSelectedOptions.value == 'Uzbek') {
      if (
        hotelNameUZ.trim() == '' ||
        hotelNameUZ.trim() == null ||
        hotelNameUZ.trim() == undefined
      ) {
        errorTmp[0].hotelNameUZ = t('Property Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(hotelNameUZ.trim(), specialCharacterRegex)) {
        errorTmp[0].hotelNameUZ = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
        isValid = false
      }

    }
    if (
      contactPersonName.trim() == '' ||
      contactPersonName.trim() == null ||
      contactPersonName.trim() == undefined
    ) {
      errorTmp[0].contactPersonName = t('Contact Person Name Is Required')
      isValid = false
    } else if (!isSpecificSpecialCharacters(contactPersonName.trim() , specialCharacterRegex)) {
      errorTmp[0].contactPersonName = t('Contact Person Name Is Not Valid')
      isValid = false
    }
    if (email == '' || email == undefined || email == null) {
      errorTmp[0].email = t('Email Is Required')
      isValid = false
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t('Please enter valid email.')
      isValid = false
    }
    if (phoneNumber == '' || phoneNumber == undefined || phoneNumber == null) {
      errorTmp[0].phoneNumber = t('Mobile Number Is required')
      isValid = false
    } else if (!Number(phoneNumber)) {
      errorTmp[0].phoneNumber = t('Only Numbers Are Allowed.')
      isValid = false
    } else if (
      ((phoneNumber != '' && phoneNumber != undefined) || phoneNumber != null) &&
      phoneNumber.length < 8
    ) {
      errorTmp[0].phoneNumber = t('Minimum 8 Digit Required')
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }
  // add hotel api call
  const addHotelsApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      const newPropertyType = propertyTypeList.flatMap((g: any) => g.options).find((o: any) => o.value == propertyTypeSelectedOptions) || null
      const newSubCategory = subCategoryList.find((o: any) => o.value == subCategorySelectedOptions) || null

      let param: any = {
        vendorId: String(selectedVendor ? selectedVendor['value'] : ''),
        en_name: hotelNameEN,
        adminId: adminId,
        ru_name: hotelNameRU,
        uz_name: hotelNameUZ,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        subcategoryId: subCategoryId,
        hotelClass: hotelClassSelectedOptions.value,
        propertyType: String(propertyTypeSelectedOptions),
        contact_person_name: contactPersonName,
        email: email,
        mobileNumber: phoneNumber,
        labels: buildDropdownAudit({
          primaryLanguage: { old: oldPrimaryLanguage, new: primaryLanguageSelectedOptions },
          hotelClass: { old: oldHotelClass, new: hotelClassSelectedOptions },
          propertyType: { old: oldPropertyType, new: newPropertyType },
          subcategoryId: { old: oldSubCategory, new: newSubCategory },
        }),
      }

      var res = await fetchData('vendor/public/addHotalV2', param)
      if (res.status == '200') {
        toastsuccessmsg('Basic Information Saved Successfully!')
        var data = res.data[0]
        sessionStorage.setItem('hotelId', data['hotelId'])
        sessionStorage.setItem('primaryLanguage', data['primaryLanguage'])
        const state = {
          hotelId: data['hotelId'],
        }
        setTimeout(() => {

          navigate(getEncryptedRoute('../addhotellocation/', { menuId: menuId }), { state })
          setDisable(false)
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setLoading(false)
        setDisable(false)
      }
    }
  }

  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)

    if (response.status == '200') {
      setHotelDetails(response.data)
      var data = response.data[0]

      var subcategory: any = []
      data.subcategory.map((val: any) => {
        subcategory.push({ value: val.subcategoryId, label: val.en_name })
      })
      setSubCategorySelectedOptions(subcategory[0] ? subcategory[0].value : [])
      setOldSubCategory(subcategory[0] || null)

      let tmpObj = {
        label: data.hotelClass + ' Star',
        value: data.hotelClass,
      }

      setHotelClassSelectedOptions(tmpObj)
      setOldHotelClass(tmpObj)
      setHotelNameEN(data.en_name)
      setHotelNameRU(data.ru_name)
      setHotelNameUZ(data.uz_name)
      setPrimaryLanguageSelectedOptions({
        value: data.primaryLanguage,
        label: `${data.primaryLanguage}`,
      })
      setOldPrimaryLanguage({
        value: data.primaryLanguage,
        label: `${data.primaryLanguage}`,
      })

      // if (data.propertyTypeDetail) {
      //   setPropertyTypeSelectedOptions(data.propertyTypeDetail[0].propertytypeId)
      // } else {
      // }

      if (data.propertyTypeDetail) {
        setPropertyTypeSelectedOptions(data.propertyTypeDetail[0].propertytypeId)
        const propTypeOption = propertyTypeList
            .flatMap((group: any) => group.options)
            .find((option: any) => option.value == data.propertyTypeDetail[0].propertytypeId)
        setOldPropertyType(propTypeOption ? { value: propTypeOption.value, label: propTypeOption.label } : null)
        const getCategoryId = propTypeOption?.categoryId || ''

        if (getCategoryId) {
          hotelSubcategoryAPIcall(getCategoryId)
        }
      }

      setContactPersonName(data.contact_person_name)
      setEmail(data.email)
      setPhoneNumber(data.mobileNumber)
      var tmp = vendorList.filter((item: any) => item.value == data.vendorId)
      setSelectedVendor(tmp.length > 0 ? tmp[0] : null)

      let selectedService = serviceList.filter(
        (item: any) => item.value == data.propertyTypeDetail[0].categoryId
      )

      setSelectedService(selectedService[0].value)
    } else {
      toasterrormsg(response.message)
    }
  }

  // edit hotel api call
  const editHotelsApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      const newPropertyType = propertyTypeList.flatMap((g: any) => g.options).find((o: any) => o.value == propertyTypeSelectedOptions) || null
      const newSubCategory = subCategoryList.find((o: any) => o.value == subCategorySelectedOptions) || null

      let param: any = {
        hotelId: editHotelId,
        vendorId: String(selectedVendor ? selectedVendor['value'] : ''),
        en_name: hotelNameEN,
        adminId: adminId,
        ru_name: hotelNameRU,
        uz_name: hotelNameUZ,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        subcategoryId: subCategoryId,
        hotelClass: hotelClassSelectedOptions.value,
        propertyType: String(propertyTypeSelectedOptions),
        contact_person_name: contactPersonName,
        email: email,
        mobileNumber: phoneNumber,
        labels: buildDropdownAudit({
          primaryLanguage: { old: oldPrimaryLanguage, new: primaryLanguageSelectedOptions },
          hotelClass: { old: oldHotelClass, new: hotelClassSelectedOptions },
          propertyType: { old: oldPropertyType, new: newPropertyType },
          subcategoryId: { old: oldSubCategory, new: newSubCategory },
        }),
      }

      var res = await fetchData('vendor/public/addHotalV2', param)
      if (res.status == '200') {
        toastsuccessmsg('Basic Information Saved Successfully!')
        var data = res.data[0]
        sessionStorage.setItem('primaryLanguage', data['primaryLanguage'])
        const state = {
          hotelId: data['hotelId'],
        }
        setTimeout(() => {
          navigate(getEncryptedRoute('../addhotellocation/', { menuId: menuId }), { state })
          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }

  // get vendor list API call
  const getvendorlist = async () => {
    let param: any = {
      categoryId: '1',
    }

    var response: any = await fetchData('admin/vendorList', param)

    if (response.status == '200') {
      var data = response.data.map((item: any) => {
        return { value: item.vendorId, label: item.fullName }
      })
      setVendorList(data)

      var tmpven: any = sessionStorage.getItem('selectedVendor')
      var selvendor: any = data.filter((item: any) => item.value == tmpven)
      setSelectedVendor(selvendor.length > 0 ? selvendor[0] : null)
    } else {
      toasterrormsg(response.message)
    }
  }

  const handleVendorChange = (e: any) => {
    setSelectedVendor(e)
    sessionStorage.setItem('vendor', e.value)
  }

  useEffect(() => {
    getvendorlist()
    document.title = 'Insayr | Accommodation Basic Info'
  }, [])

  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
  }, [vendorList, propertyTypeList])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editHotelId != '' ? t('Edit Basic Information') : t('Add Basic Information')}
      </PageTitle>
      <AddHotelHeader hotelId={editHotelId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Property Basic Information')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {hotelDetails.length != 0 ? (
                            <>
                              {hotelDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['roomAndSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>
                              {t('Primary Language')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='primaryLanguage[]'
                              id='primaryLanguage'
                              placeholder={t('Select Primary Language')}
                              isSearchable={true}
                              options={primaryLanguageList}
                              value={primaryLanguageSelectedOptions}
                              onChange={(e: any) => {
                                changePrimaryLanguage(e)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Select Vendor')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='vendor'
                              id='vendorId'
                              isDisabled={editHotelId != ''}
                              placeholder={t('Select Vendor')}
                              isSearchable={true}
                              options={vendorList}
                              value={selectedVendor}
                              onChange={handleVendorChange}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].vendorId}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--begin::Card body--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {primaryLanguageSelectedOptions.value == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Property Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameEN}
                                  onChange={(e) => {
                                    setHotelNameEN(e.target.value)
                                    removeError('hotelNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].hotelNameEN}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameRU}
                                  onChange={(e) => {
                                    setHotelNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameUZ}
                                  onChange={(e) => {
                                    setHotelNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Property Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameRU}
                                  onChange={(e) => {
                                    setHotelNameRU(e.target.value)
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].hotelNameRU}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameEN}
                                  onChange={(e) => {
                                    setHotelNameEN(e.target.value)
                                    removeError('hotelNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameUZ}
                                  onChange={(e) => {
                                    setHotelNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Property Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameUZ}
                                  onChange={(e) => {
                                    setHotelNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].hotelNameUZ}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameRU}
                                  onChange={(e) => {
                                    setHotelNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Property Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='hotelNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Property Name')}
                                  value={hotelNameEN}
                                  onChange={(e) => {
                                    setHotelNameEN(e.target.value)
                                    removeError('hotelNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                      </div>
                      {/* <!--begin::Card body--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        <div className='row'>
                          {/* <div className='col-lg-4 my-3'>
                            <label className='fs-4  form-label'>Select Service</label>
                            <Select
                              name='selectService'
                              id='selectService'
                              placeholder='Select Service'
                              isSearchable={true}
                              options={serviceList}
                              value={
                                serviceList.find(
                                  (option: any) => option.value == selectedService
                                ) || null
                              }
                              onChange={(e: any) => {
                                setSelectedService(e.value)
                              }}
                            />
                          </div> */}
                          <div className='col-lg-4 my-3'>
                            <label className='fs-4 required form-label'>{t('Property Type')}</label>
                            <Select
                              name='propertyType'
                              id='propertyType'
                              placeholder={t('Select Property Type')}
                              isSearchable={true}
                              options={propertyTypeList}
                              value={
                                propertyTypeList
                                  .flatMap((group: any) => group.options) // Flatten options array
                                  .find(
                                    (option: any) => option.value == propertyTypeSelectedOptions
                                  ) || null
                              }
                              onChange={(e: any) => {
                                setPropertyTypeSelectedOptions(e.value)
                                hotelSubcategoryAPIcall(e.categoryId)
                                removeError('propertyType')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].propertyType}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='required fs-4 form-label'>
                              {t('Property Category')}
                            </label>
                            <Select
                              name='subCategory[]'
                              id='subCategoryListId'
                              placeholder={t('Select Category')}
                              isSearchable={true}
                              options={subCategoryList}
                              value={
                                subCategoryList.find(
                                  (option: any) => option.value == subCategorySelectedOptions
                                ) || null
                              }
                              onChange={(e: any) => {
                                setSubCategorySelectedOptions(e.value)
                                removeError('subCategoryId')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].subCategoryId}</div>
                          </div>

                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>
                              {t('Property Class')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='hotelClass[]'
                              id='hotelClassList'
                              placeholder={t('Select Property Class')}
                              isSearchable={true}
                              options={hotelClassList}
                              value={hotelClassSelectedOptions}
                              onChange={(e: any) => {
                                setHotelClassSelectedOptions(e)
                                removeError('hotelClass')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].hotelClass}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* end::Form group */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>
                              {t('Contact Person Name')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='contactPersonName'
                              className='form-control mb-2'
                              placeholder={t('Contact Person Name')}
                              value={contactPersonName}
                              onChange={(e) => {
                                setContactPersonName(e.target.value)
                                removeError('contactPersonName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Email')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='email'
                              className='form-control mb-2'
                              placeholder={t('Email')}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value)
                                removeError('email')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].email}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Phone Number')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='phoneNumber'
                              className='form-control mb-2'
                              placeholder={t('Phone Number')}
                              value={phoneNumber}
                              onChange={(e) => {
                                setPhoneNumber(e.target.value)
                                removeError('phoneNumber')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <Link
                  to={getEncryptedRoute('../viewhotels/', { menuId: menuId })}
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                >
                  {t('Cancel')}
                </Link>

                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={() => {
                    if (editHotelId !== '') {
                      editHotelsApi()
                    } else {
                      addHotelsApi()
                    }
                  }}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddHotelBasicInfo }
